import { styled, TextField } from "@mui/material";
import React from "react";
import { SearchColumn } from "../../DashboardInfo/DashboardInfo.style";

const CssTextField = styled(TextField)({
  "& label.Mui-focused": {
    color: "green",
  },
  "& .MuiInput-underline:after": {
    borderBottomColor: "green",
  },
  "& .MuiOutlinedInput-root": {
    "& fieldset": {
      borderColor: "red",
    },
    "&:hover fieldset": {
      borderColor: "yellow",
    },
    "&.Mui-focused fieldset": {
      borderColor: "green",
    },
  },
});

const ColumnFilter = ({ column }) => {
  const { filterValue, setFilter } = column;
  return (
    <SearchColumn>
      <span>
        <CssTextField
          focused
          sx={{
            mt: "8px",
          }}
          size="small"
          style={{
            width: "75%",
            borderRadius: "1px",
            padding: "2px",
          }}
          value={filterValue || ""}
          onChange={(e) => setFilter(e.target.value)}
        />
      </span>
    </SearchColumn>
  );
};

export default ColumnFilter;
